window.ResinComparison = (function () {

  const MAX_DESKTOP = 3;
  const MAX_MOBILE = 2;

  function getMaxSlots() {
    return window.innerWidth <= 920 ? MAX_MOBILE : MAX_DESKTOP;
  }

  function init(sectionId) {
    const dataEl = document.getElementById(`product-data-${sectionId}`);
    if (!dataEl) return;

    const products = JSON.parse(dataEl.textContent);
    const container = document.querySelector('[data-comparison-grid]');
    if (!container) return;

    let slots = Array.from({ length: getMaxSlots() }, () => null);

    /* ---------- RESIZE ---------- */
    window.addEventListener('resize', () => {
      const max = getMaxSlots();
      if (slots.length !== max) {
        slots = Array.from({ length: max }, (_, i) => slots[i] || null);
        render();
      }
    });

    /* ---------- RENDER ---------- */
    function render() {
      container.innerHTML = slots.map((slot, index) => {
        if (!slot) {
          return `
            <div class="compare-card compare-card--empty">
              <div class="product-picker-inline">
                <button class="product-picker__toggle" data-slot="${index}">
                  Select a Resin
                </button>
                <div class="product-picker__menu">
                  ${Object.values(products).map(p => `
                    <button class="product-picker__option"
                            data-slot="${index}"
                            data-product-id="${p.id}">
                      ${p.title}
                    </button>
                  `).join('')}
                </div>
              </div>
            </div>
          `;
        }

        const p = slot;
        return `
          <div class="compare-card">
            <div class="compare-card-image"><a href="${p.url}" ><img src="${p.image}" alt="${p.title}" loading="lazy" /></a></div>
            <div class="compare-card-title"><h5>${p.title}</h5></div>
           <div class="compare-card-table rte">
            <table>
             ${p.short_description && p.short_description.trim() ? `<tr><td colspan="2">${p.short_description}</td></tr>` : ''}

${p.tensile_strength && p.tensile_strength.toString().trim() ? `<tr><td>Ultimate Tensile Strength</td><td>${p.tensile_strength}</td></tr>` : ''}

${p.elongation_stress && p.elongation_stress.toString().trim() ? `<tr><td>Stress at 100% Elongation</td><td>${p.elongation_stress}</td></tr>` : ''}

${p.elongation_break && p.elongation_break.toString().trim() ? `<tr><td>Elongation at Break</td><td>${p.elongation_break}</td></tr>` : ''}

${p.tensile_modulus && p.tensile_modulus.toString().trim() ? `<tr><td>Tensile Modulus</td><td>${p.tensile_modulus}</td></tr>` : ''}

${p.flexural_strength && p.flexural_strength.toString().trim() ? `<tr><td>Flexural Strength</td><td>${p.flexural_strength}</td></tr>` : ''}

${p.flexural_modulus && p.flexural_modulus.toString().trim() ? `<tr><td>Flexural Modulus</td><td>${p.flexural_modulus}</td></tr>` : ''}

${p.notched_izod && p.notched_izod.toString().trim() ? `<tr><td>Notched Izod Impact</td><td>${p.notched_izod}</td></tr>` : ''}

${p.heat_def_oneeight && p.heat_def_oneeight.toString().trim() ? `<tr><td>Heat Deflection Temp (1.8 MPa)</td><td>${p.heat_def_oneeight}</td></tr>` : ''}

${p.heat_def_zerofour && p.heat_def_zerofour.toString().trim() ? `<tr><td>Heat Deflection Temp (0.45 MPa)</td><td>${p.heat_def_zerofour}</td></tr>` : ''}

${p.thermal_expansion && p.thermal_expansion.toString().trim() ? `<tr><td>Thermal Expansion</td><td>${p.thermal_expansion}</td></tr>` : ''}

${p.unnoticed_izod && p.unnoticed_izod.toString().trim() ? `<tr><td>Unnotched Izod Impact</td><td>${p.unnoticed_izod}</td></tr>` : ''}

${p.gardner_at_onethirtytwo && p.gardner_at_onethirtytwo.toString().trim() ? `<tr><td>Gardner Impact (1/32" / 0.97 mm)</td><td>${p.gardner_at_onethirtytwo}</td></tr>` : ''}

${p.gardner_at_onesixteenth && p.gardner_at_onesixteenth.toString().trim() ? `<tr><td>Gardner Impact (1/16" / 1.9 mm)</td><td>${p.gardner_at_onesixteenth}</td></tr>` : ''}

${p.kmax && p.kmax.toString().trim() ? `<tr><td>Maximum Stress Intensity Factor (Kmax)</td><td>${p.kmax}</td></tr>` : ''}

${p.work_of_fracture && p.work_of_fracture.toString().trim() ? `<tr><td>Work of Fracture (Wf)</td><td>${p.work_of_fracture}</td></tr>` : ''}

${p.tear_strength && p.tear_strength.toString().trim() ? `<tr><td>Tear Strength</td><td>${p.tear_strength}</td></tr>` : ''}

${p.ross_flexing && p.ross_flexing.toString().trim() ? `<tr><td>Ross Flexing</td><td>${p.ross_flexing}</td></tr>` : ''}

${p.shore_hardness && p.shore_hardness.toString().trim() ? `<tr><td>Shore Hardness</td><td>${p.shore_hardness}</td></tr>` : ''}
            </table>
            </div>
            <div class="actions">
            ${p.price}
              <a href="${p.url}" class="button--primary">View Product</a>
              <a href="javascript:void(0)" class="remove-button" data-remove="${index}">Remove</a>
            </div>
          </div>
        `;
      }).join('');

      requestAnimationFrame(attachEvents);
    }

    /* ---------- EVENTS ---------- */
    function attachEvents() {
      container.querySelectorAll('.product-picker__toggle').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const menu = e.target.nextElementSibling;
          menu.classList.toggle('open');
        });
      });

      container.querySelectorAll('.product-picker__option').forEach(btn => {
        btn.addEventListener('click', () => {
          slots[btn.dataset.slot] = products[btn.dataset.productId];
          render();
        });
      });

      container.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', () => {
          slots[btn.dataset.remove] = null;
          render();
        });
      });

      document.addEventListener('click', (e) => {
        document.querySelectorAll('.product-picker__menu.open').forEach(menu => {
          if (!menu.parentElement.contains(e.target)) {
            menu.classList.remove('open');
          }
        });
      });
    }

    render();
  }

  return { init };
})();